$(function() {

  $('[data-mh]').matchHeight();
  $('[data-mhnr]').matchHeight({byRow: false});



  if($('[data-headercolor="light"]').length ) {
    $('body').addClass('has-hero');
    $('body').addClass('headercolor-light');
  }


  if($('.lhsection-fullhero').length || $('.lhsection-halfhero').length ) {
    getHeroHeight();

    $('body').addClass('has-hero');

    // if($('.hero-wrap').attr("data-headercolor") == 'light') {
    //   $('body').addClass('headercolor-light');
    // }

    $(window).resize(function() {

      window.setTimeout(function () {
        getHeroHeight();
      }, 100);

    });
  }

  // FULL HERO SLIDER
    if($('.fullhero-slides[data-autoplay]').length) {
      var aspotAutoplayOption = true;
      var aspotSlidesSpeed = $('.fullhero-slides').attr('data-autoplay');
    } else {
      var aspotAutoplayOption = false;
      var aspotSlidesSpeed = 0;
    }

    var $heroSlider = $('.fullhero-slides').not('.slick-initialized').slick({
      fade: true,
      speed: 400,
      // cssEase: 'var(--trans-function)',
      dots: false,
      // appendDots: '.fullhero-slides ~ .slider-footer .slider-dots',
      arrows: true,
      appendArrows: '.fullhero-slides ~ .slider-footer',
      prevArrow: '<button class="slide-prev"><i></i></button>',
      nextArrow: '<button class="slide-next"><i></i></button>',

      slidesToShow: 1,
      slidesToScroll: 1,

      infinite: true,
      centerMode: false,
      // centerPadding: '0',
      autoplay: aspotAutoplayOption,
      autoplaySpeed: aspotSlidesSpeed,
      pauseOnFocus: true,
      pauseOnHover: true,

      swipeToSlide: true,
      draggable: true,
      touchThreshold: 400,
      touchMove: true,
    });

    // $heroSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
    //   bLazy.revalidate();
    // });

    // $heroSlider.on('afterChange', function(event, slick, currentSlide, nextSlide){
    //   bLazy.revalidate();
    // });





  function getHeroHeight() {

    var topbarHt = 0;
    var headerHt = $('.theme__header').outerHeight();

      if($('#shopify-section-announcement').length) {
        $('body').addClass('has-topbar');
        topbarHt = $('#shopify-section-announcement').outerHeight();
      }

      // var totalHt = (topbarHt + headerHt) * -1;
      var totalHt = headerHt * -1;

      $('.lhsection-hero .hero-wrap').css('margin-top', totalHt+'px');

  }


  if($('.lhsection-fullhero').length) {

    if ($('html').is('.touchevents, .mobile, .tablet') ) {

      if($('#shopify-section-announcement').length) {
        var topbarHt = $('#shopify-section-announcement').outerHeight();

        var windowHeight = $(window).height();
        var windowHeight = windowHeight - topbarHt;

        $('.lhsection-fullhero .hero-wrap').css('height', windowHeight+'px');

      }

    } else {
      $(window).bind('load resize', function(){
        // var windowHeight = $(window).height();

        var topbarHt = $('#shopify-section-announcement').outerHeight();

        var windowHeight = $(window).height();
        var windowHeight = windowHeight - topbarHt;

        $('.lhsection-fullhero .hero-wrap').css('height', windowHeight+'px');
      });
    }

  }




  // checkMobileWidth();

  // $(window).resize(function() {
  //   checkMobileWidth();
  // });

  // function checkMobileWidth() {
  //   if($('#shopify-section-header_lh').width() > 989) {
  //     $('[data-header-wrapper]').removeClass('js__show__mobile');
  //   } else {
  //     $('[data-header-wrapper]').addClass('js__show__mobile');
  //   }
  // }






  // COLLECTION STUFF


  // SCROLL TO TOP ON FILTER CLICK
  if($('body.template-collection').length) {

    // $('.collection__sidebar__group .collection-nav .sidebar__item').find('input').change(function() {
    //   var sectionTop = $(this).parents('.collection-products').offset().top;

    //   console.log(sectionTop)

    //   $('html').scrollTop(sectionTop);
    // });

    // $('.collection__sidebar__group .collection-nav .sidebar__item label').click(function() {

    //   var sectionTop = $(this).parents('.collection-products').offset().top;

    //   console.log(sectionTop)

    //   $('html').scrollTop(sectionTop);

    // });
  }



  if($('body.template-collection').length && $('.halfhero-titlewrap').length) {
    $('.lhsection-halfhero').addClass('halfhero-onlytitle');
  }



  function scrollTopFilter() {

    $('.collection__sidebar__group .collection-nav .sidebar__item').find('input').change(function() {
      var sectionTop = $(this).parents('.collection-products').offset().top;
      $('html').scrollTop(sectionTop);
    });

    $('.collection__sidebar__buttons [data-filter-update-url]').click(function() {
      var sectionTop = $(this).parents('.collection-products').offset().top;
      $('html').scrollTop(sectionTop);
    });


    $('#sort-list .popout-list__item a').click(function() {
      var sectionTop = $(this).parents('.collection-products').offset().top;
      $('html').scrollTop(sectionTop);
    });

  }



  function filterCounter() {

    $('.collection__sidebar__group').each(function(index) {
      if($(this).find('.collection-nav li').length == 1) {
        $(this).addClass('filter-single');
      }
    });

    var filterCount = $('.collection__sidebar').attr('data-active-filters-count');

    $('.collection-products').attr('data-filter-count', filterCount);

  }



  if($('body.template-collection').length) {

    $('.collection__sidebar__group').each(function(index) {
      if($(this).find('.collection-nav li').length == 1) {
        $(this).addClass('filter-single');
      }
    });


    // SCROLL TO TOP ON FILTER CLICK
    scrollTopFilter();
  }




  // MAKING SWATCHES SHOW BACK UP WHEN CHOOSING A FILTER
  if($('body.template-collection').length) {



    var filterCount = $('.collection__sidebar').attr('data-active-filters-count');

    $('.collection-products').attr('data-filter-count', filterCount);


    // NEW DOMTREEMODIFIED

    // Select the node that will be observed for mutations
    var targetNode = document.getElementById('lh-prodgrid');

    var config = { attributes: true, childList: true };

    var callback = function(mutationsList) {
      for(var mutation of mutationsList) {

        if (mutation.type == 'childList') {
          // console.log('A child node has been added or removed.');
          scrollTopFilter();
          filterCounter();
        }

        else if (mutation.type == 'attributes') {
          // console.log('The ' + mutation.attributeName + ' attribute was modified.');
        }

      }
    };

    // Create an observer instance linked to the callback function
    var observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);






    // $('.product-grid-outer').on('DOMSubtreeModified', function(){

    //     // window.setTimeout(function () {

    //     //   // $('.swatch__button').each(function(index) {
    //     //   //   $(this).find('[data-swatch-input][disabled]').parents('.swatch__button').addClass('swatch-disabled')
    //     //   // });

    //     //   $('.product-item__swatched__holder').addClass('swatches-ready');

    //     // }, 1000);

    //     $('.collection__sidebar__group').each(function(index) {
    //       if($(this).find('.collection-nav li').length == 1) {
    //         $(this).addClass('filter-single');
    //       }
    //     });

    //     var filterCount = $('.collection__sidebar').attr('data-active-filters-count');

    //     $('.collection-products').attr('data-filter-count', filterCount);



    // });



    // SWATCH LINK CLICK

      window.setTimeout(function () {

        swatchImageChange();

        swatchURLChange();


      }, 2000);


      $('.collection__sidebar__slider').click(function() {

        window.setTimeout(function () {

          swatchImageChange();

          swatchURLChange();


        }, 2000);

      });


  }

  if($('body').hasClass('template-page') && $('.ts-featuredcollection').length ) {


    window.setTimeout(function () {

      swatchImageChange();

      swatchURLChange();


    }, 2000);

  }

  if($('body').hasClass('template-product')) {


    // THIS WEAK SHIT IS LOOKING TO SEE IF THE PRODUCT HAS A VARIABT PRE SELECTED
    // AND IS UPDATING THE IMAGE TO REFLECT IT

    var urlParams = new URLSearchParams(window.location.search);
    var hasVariant = urlParams.get('variant');


    window.setTimeout(function () {

      if(hasVariant) {
        var checkedInput = $('.product__form__outer').find('.selector-wrapper[data-option-position="1"] .swatch__button > input[type="radio"][checked]');

        var checkedInputID = $(checkedInput).attr('id');

        $(checkedInput).prop('checked', false);

        $(checkedInput).next('label').click();
      }

    }, 500);




    $('.related__placeholder').on('DOMNodeRemoved', function(){
      console.log('removed')

      window.setTimeout(function () {

        swatchImageChange();

        swatchURLChange();


      }, 2000);
    });



  }



  function swatchImageChange() {

    $('.product-item__swatched__holder .swatch__button').mouseover(function() {
      var varName = $(this).find('label[data-variant-name]').attr('data-variant-name');
      $(this).parents('.product-item').find('.product-item__bg__inner[data-variant-title="'+varName+'"]').addClass('is-visible');
    }).mouseout(function() {
      $(this).parents('.product-item').find('.product-item__bg__inner.is-visible').removeClass('is-visible');
    });

  }

  function swatchURLChange() {

    $('.product-link').hover(function() {

      var origURL = $(this).attr('href').split('?')[0];

      $(this).find('.swatch__button').mouseover(function() {
        var varID = $(this).find('input[data-swatch-input]').attr('data-variant');
        $(this).parents('.product-link').attr('href', origURL + '?variant=' + varID)
      }).mouseout(function() {
        $(this).parents('.product-link').attr('href', origURL);
      });

    });

  }



  // PRODUCT STUFF

  if($('body.template-product').length) {

    var titleParent = $('body.template-product').find('.product__title__wrapper');
    $('body.template-product').find('.product__block.product__price__wrap').appendTo(titleParent);

  }

  if($('body.template-product').length && $('#shopify-section-template--14600366325795__imgtxt').length) {

    var h2Txt = $('#shopify-section-template--14600366325795__imgtxt').find('h2').text();

    if(h2Txt == 'Love ') {
      $('#shopify-section-template--14600366325795__imgtxt').hide();
    }

  }




  // WISHLIST


  // if($('body.template-product').length && $('.product__block .swym-wishlist-button-bar').length && $('.product__block .share-holder').length) {

  //   var wishParent = $('body.template-product').find('.product__block .swym-wishlist-button-bar').parents('.product__block');
  //   $('body.template-product').find('.product__block share-button.share-holder').appendTo(wishParent);
  //   $(wishParent).addClass('wish-share-wrap');

  // }



  if($('body.template-product').length && $('.product__block .swym-wishlist-button-bar').length && $('.product__block.share-wrap').length) {

    var shareWrap = $('body.template-product').find('.product__block.share-wrap');

    $('body.template-product').find('.product__block .swym-wishlist-button-bar').prependTo(shareWrap);

    $(shareWrap).addClass('wish-share-wrap');

  }












  // CHOOSE AVAILABLE FINISH ON COLOR CLICK
  if($('body.template-product').length) {


      const newVarOpts = varOpts.reduce((acc, {color, quant}) => {
        const existing = acc.find(i => i.color === color)
        if (existing) { existing.quant.push(quant) }
        else {acc.push({color, quant: [quant]})}

        return acc
      }, [])

      newVarOpts.forEach(function(item) {
        var col = item.color;
        var qua = item.quant;
        if(qua == 0) {
          $('.selector-wrapper[data-option-position="1"] .swatch__button[data-tooltip="'+col+'"]').addClass('nostock');
        }
      });

    window.setTimeout(function () {
      $('[data-option-position="2"] .swatch__button input:not(.unavailable, .sold-out)').first().next('label').click();
    }, 100);

    $('[data-option-position="1"] [data-swatch]').click(function() {

      window.setTimeout(function () {
        // $('[data-option-position="2"] .swatch__button input:not(.sold-out, .unavailable)').first().next('label').click();

        $('[data-option-position="2"] .swatch__button input:not(.unavailable, .sold-out)').first().next('label').click();

        // $('[data-option-position="2"] .swatch__button input').not('.sold-out, .unavailable').next('label').click();


        // 2025 - SCROLL TO TOP ON SWATCH CLICK
        var topOfProducts =  $('#TemplateProduct').offset().top;
        $('html').scrollTop(topOfProducts);

      }, 10);

    });


    $('[data-option-position="2"] [data-swatch]').click(function() {

      window.setTimeout(function () {
        // 2025 - SCROLL TO TOP ON SWATCH CLICK
        var topOfProducts =  $('#TemplateProduct').offset().top;
        $('html').scrollTop(topOfProducts);
      }, 10);

    });


  }



  // CHANGE PRODUCT DESCRIPTION BASED ON VARIANT SELECTED
  // LOOK FOR EM IN PARAGRAPH TEXT, IDENTIFY ONE AND TWO
  if($('body.template-product').length) {

    if ($('.product__tabs .metafield-rich_text_field').length) {

      // if ($('.metafield-rich_text_field p > em').length && $('.metafield-rich_text_field p > em').length == 2) {
      //   $('.metafield-rich_text_field p > em').first().attr('id', 'finishText');
      //   $('.metafield-rich_text_field p > em').first().next().attr('id', 'colorText');

      //   var colorText = $('em#colorText');
      //   var finishText = $('em#finishText');

      //   $('[data-option-position="2"]').find('[data-option-value]').on('DOMSubtreeModified', function(){
      //     var newFinishText = $('[data-option-position="2"]').find('[data-option-value]').text();

      //     finishText.text(newFinishText);
      //   });

      //   $('[data-option-position="1"]').find('[data-option-value]').on('DOMSubtreeModified', function(){
      //     var newColorText = $('[data-option-position="1"]').find('[data-option-value]').text();

      //     colorText.text(newColorText);
      //   });

      // }

      if ($('.metafield-rich_text_field em').length && $('.metafield-rich_text_field em').length == 2) {
        $('.metafield-rich_text_field em').first().attr('id', 'finishText');
        $('.metafield-rich_text_field em').last().attr('id', 'colorText');
        // $('.metafield-rich_text_field em').first().next().attr('id', 'colorText');

        var colorText = $('em#colorText');
        var finishText = $('em#finishText');

        $('[data-option-position="2"]').find('[data-option-value]').on('DOMSubtreeModified', function(){
          var newFinishText = $('[data-option-position="2"]').find('[data-option-value]').text();

          finishText.text(newFinishText);
        });

        $('[data-option-position="1"]').find('[data-option-value]').on('DOMSubtreeModified', function(){
          var newColorText = $('[data-option-position="1"]').find('[data-option-value]').text();

          colorText.text(newColorText);
        });

      }

    }

    if($('.prod-custcaretxt').length) {

      $('[data-rowname="measurements-materials--care"] .accordion-content').find('.metafield-rich_text_field + h5').nextAll().remove();

      $('.prod-custcaretxt .metafield-rich_text_field').appendTo('[data-rowname="measurements-materials--care"] > .accordion-content');

    }



  }


  // MAKING PRODUCT FORM STICKY
  if ($('body.template-product').length) {
    if ($('.lifestyle_imgs').length) {
      var hdrHt = $('.header__desktop').outerHeight();
      $('.product__content .form__wrapper').addClass('make-sticky');
      $('.product__content .form__wrapper').attr('style', '--sticky-top: '+hdrHt+'px');
    }
  }




  // LINKHOVERS
    if($('.linkhover-wrapper').length) {

      $('[data-linkhover]').mouseenter(function(){
        var toHover = $(this).attr("data-linkhover");

        if($('.linkhover-image#'+toHover).hasClass('is-active')) {
        } else {
          $('.linkhover-image.is-active').removeClass('is-active');
          $('.linkhover-image#'+toHover).addClass('is-active');
        }

      });

    }


    // MENU IMAGE HOVER
    if($('.imghover-wrapper').length) {

      $('[data-imghov]').mouseenter(function(){
        var toHover = $(this).attr("data-imghov");

        if($('.imghover-single#imghover-'+toHover).hasClass('active')) {
        } else {
          $(this).parents('.menu__item').find('.imghover-single.active').removeClass('active');
          // $('.imghover-single.active').removeClass('active');
          $('.imghover-single#imghover-'+toHover).addClass('active');
        }

      });

    }




  // FOIL SWATCHES

    if($('#foilSwatchContainer').length) {

      foilSwatches.forEach((value) => {
        $('#foilSwatchContainer').append('<div class="foil-swatch"><div class="swatch-img"><img src="'+value.foilImg+'"></div><div class="swatch-txt"><h5>'+value.foilName+'</h5></div></div>');
      });

    }




  // TRIGGER SEARCH FROM EMPTY CART

  $('.cart-drawer__empty a[href="/search"]').on('click', function (e) {
    e.preventDefault();
    $('.cart-drawer__close')[0].click();
    window.setTimeout(function () {
      $('.header__desktop__button [data-popdown-toggle="search-popdown"]')[0].click();
    }, 200);
  });


  $('.cart__empty a[href="/search"]').on('click', function (e) {
    e.preventDefault();
    window.setTimeout(function () {
      $('.header__desktop__button [data-popdown-toggle="search-popdown"]')[0].click();
    }, 200);
  });

  // SEARCH TRIGGER CLASSES

  // $(document).on('click', function (e) {
  //   if ( $('body').hasClass ) {

  //       $('body').removeClass('search-open');

  //   }
  // });






  var hlight = false;

  $(document).click(function(event){
    if(!$(event.target).closest("#search-popdown").length) {
      $('body').removeClass('search-open');

      if (hlight == true) {
        $('body').addClass('headercolor-light')
      }
    }
  });

  $('[data-popdown-toggle="search-popdown"]').on('click', function (e) {
    e.preventDefault();

    if($('body').hasClass('headercolor-light')) {
      hlight = true;
    } else {
      hlight = false;
    }


    window.setTimeout(function () {

      $('body').addClass('search-open');

      if (hlight == true) {
        $('body').removeClass('headercolor-light')
      }

    }, 1);

  });


  $('.search-popdown__close__button').on('click', function (e) {
    e.preventDefault();
    $('body').removeClass('search-open');

    if (hlight == true) {
      $('body').addClass('headercolor-light')
    }

  });


  $('.header__menu .menu__item.grandparent a').hover(function() {
    if($('body').hasClass('search-open')) {
      $('.search-popdown__close__button')[0].click();
    }
  });




  // HOMEPAGE HOTSPOT SLIDER HACK

    // Function to check if an element is in view
    function topInView(element) {
      var imgHt = $(element).find('> *:first-child').height();
      var elementTop = element.offset().top;
      var elementBottom = elementTop + (element.outerHeight() + 200);
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();
      var viewportBottom = viewportBottom - imgHt;
      return (elementTop <= viewportTop && elementBottom >= viewportBottom);
    }

    function botInView(element) {
      var elementTop = element.offset().top;
      var elementBottom = elementTop + element.outerHeight();
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();
      return (elementBottom <= viewportBottom && elementBottom >= viewportBottom);
    }



    // Check element position on scroll
    if($('body').hasClass('template-index') && $('[data-section-type="look"]').length) {

      $(window).scroll(function() {
        var targetElement = $('.look');
        var parentElement = $('.look');

        if (topInView(targetElement)) {
          $('body').addClass('look-locked');
        } else {
          $('body').removeClass('look-locked');
        }

        if (botInView(targetElement)) {
          $('body').addClass('bot-locked');
        } else {
          $('body').removeClass('bot-locked');
        }

      });

      window.setTimeout(function () {

        $('.look__dot__button').unbind("click").bind("click", function(){

          var slideNum = $(this).attr('data-slider-thumb');
          var topPos = $('[data-slide="lookbook-'+slideNum+'"]').offset().top;
          var topPos = topPos - 150;

          $('html').scrollTop(topPos);
        });

      }, 1000);



    }


  if($('body').hasClass('template-index')) {



    $('.video__player').on('DOMSubtreeModified', function(){


        playVideos();

    });






  }

  function playVideos(){
    $("video").each(function(index){
        $(this).get(0).load();
        $(this).get(0).addEventListener("canplaythrough", function(){
            this.play();

        });
    });
  }


 if($('body').hasClass('template-product')) {

    window.setTimeout(function () {
      getShareBtnPosition();
    }, 4000);

    $(window).resize(function() {
      getShareBtnPosition();
    });

  }


  function getShareBtnPosition(){
    var posTop = $('.share-wrap.wish-share-wrap').offset().top - $(window).scrollTop();
    var posLef = $('.share-wrap.wish-share-wrap').offset().left;
    $('.swym-wishlist-notifications-container').css('top', posTop+'px').css('left', posLef+'px');

    $(window).scroll(function() { //when window is scrolled
      var posTop = $('.share-wrap.wish-share-wrap').offset().top - $(window).scrollTop();
      $('.swym-wishlist-notifications-container').css('top', posTop+'px');
    });
  }







});